
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/screens/dashboard/services/dashboard.service';
import { LoaderService } from '../services';

export enum NotificationSlug {
  PROGRESS_REPORT = 'PROGRESS_REPORT',
}

@Component({
  selector: 'app-quick-icons',
  templateUrl: './quick-icons.component.html',
  styleUrls: ['./quick-icons.component.scss']
})

export class QuickIconsComponent implements OnInit {
  isProgressReportNotification: boolean = false;
  notificationData: any[] = [];
  notificationUnreadCount: number = 0;
  icons: { name: string, icon: string, status: string, color: string }[] = [
    { name: 'Progress Report', icon: 'pi pi-book', status: NotificationSlug.PROGRESS_REPORT, color: '#F97316' },
  ];

  onIconClick(status: string) {
    if (status === NotificationSlug.PROGRESS_REPORT) {
      this.isProgressReportNotification = true;
      this.getProgressReportNotification();
    }
  }

  constructor(
    private dashboardService: DashboardService,
    private router: Router,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
     this.dashboardService.notificationReport$.subscribe((hasNewNotification: boolean) => {
    if (hasNewNotification) {
      this.getProgressReportNotification();
    }
  });
    this.getProgressReportNotification();
  }

getProgressReportNotification(): void {
  this.loaderService.isLoading.next(true);
  this.dashboardService.getAllNotifications(NotificationSlug.PROGRESS_REPORT).subscribe({
    next: (res: any) => {
      this.loaderService.isLoading.next(false);

      const notifications = res?.data || [];
      this.notificationData = notifications.map((item: any) => ({
        ...item,
        patientName: item.notificationBody?.patient_name || 'a patient',
        createdTime: new Date(item.createdAt).toLocaleString()
      }));

      this.notificationUnreadCount = this.notificationData.filter(n => !n.isReadDashboardNotification).length;

      // Show notification only first time in this tab (not on refresh)
      const hasVisitedBefore = sessionStorage.getItem('hasVisitedProgressNotification');

      if (!hasVisitedBefore && this.notificationUnreadCount > 0) {
        this.isProgressReportNotification = true;

        // Mark user as visited so we don't show again in this session
        sessionStorage.setItem('hasVisitedProgressNotification', 'TRUE');

        // Optional: only mark sidebar open after first-time show
        sessionStorage.setItem('isProgressSidebarOpen', 'TRUE');
      }
    },
    error: () => this.loaderService.isLoading.next(false)
  });
}

  navigateToProgressReport(notification: any): void {
    this.isProgressReportNotification = false;
    // this.markNotificationAsRead(notification.notificationId);
    this.router.navigate([`/patientregistration/edit-patient/${notification.notificationBody?.patient_id}`])
      .then(() => window.location.reload());
  }

  // markNotificationAsRead(notificationId: string): void {
  //   const payload = { isReadDashboardNotification: true };
  //   this.dashboardService.updateNotification(notificationId, payload).subscribe({
  //     next: () => this.getProgressReportNotification(),
  //     error: err => console.error('Failed to mark notification as read:', err)
  //   });
  // }


}
